export const shapes = {
  homeItemBox: require('./home_item_box.png'),
  reportItemBox: require('./report_item_box.png'),
};
